// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from 'informed';
import { Link } from 'react-router-dom';
import moment from 'moment';

import ContentBox from '../ContentBox.jsx';
import PageHeader from '../PageHeader.jsx';
import Header from '../Header.jsx';
import { PrimaryButton, Button } from '../Buttons.jsx';
import BasicInfoSection from './BasicInfoSection.jsx';

import { SERVER_ADDRESS, fetchGet } from '../../util/actionsUtil';
import { updateGeneralInfo } from '../../actions/informationHistoryActions';

import styles from '../../styles/AddPatientPage.scss';

type Props = {
  patient: Object,
  updateGeneralInfo: Function,
}

type State = {
  patientId: ?string,
}

class AddPatientPageComponent extends Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.state = {
      patientId: null,
    };
  }

  formApi: {
    getState: Function,
  };

  setFormApi = (formApi: Object) => {
    this.formApi = formApi;
  }

  handleSave = () => {
    const { invalid, values } = this.formApi.getState();
    if (invalid) {
      return;
    }

    fetchGet(`${SERVER_ADDRESS}/patient/addNewPatient`,
      (data) => {
        const { patientId } = data;
        const generalInfo = {
          patientId,
          firstName: values.firstName,
          siswatiName: values.siswatiName,
          surname: values.surname,
          sex: values.sex,
          dob: moment(values.dob, 'DD-MM-YYYY').toISOString(),
          dateArrived: moment(values.dateArrived, 'DD-MM-YYYY').toISOString(),
        };
        this.props.updateGeneralInfo(patientId, generalInfo);
        this.setState(prevState => ({
          ...prevState,
          patientId,
        }));
      },
      () => {
        // error: do nothing?
      });
  }

  render() {
    return (
      <div className={styles.addPatientPage}>
        <Header />
        <Form getApi={this.setFormApi} autoComplete="off" className={styles.form}>
          <PageHeader title="Add New Patient" />
          <BasicInfoSection editing={!this.state.patientId} />
          {!this.state.patientId
            && <ContentBox>
              <PrimaryButton onClick={this.handleSave}>Create Patient</PrimaryButton>
              <Link to={'/search'}><Button>Cancel</Button></Link>
            </ContentBox>
          }
        </Form>
        <div className={styles.form}>
          {this.state.patientId && this.props.patient.status === 'SUCCESS'
            && <ContentBox>
              <Link to={`/patient/${this.state.patientId}`}><PrimaryButton>Go to Patient Page</PrimaryButton></Link>
            </ContentBox>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  patient: state.patient,
});

const mapDispatchToProps = dispatch => ({
  updateGeneralInfo:
    (patientId, values) => dispatch(updateGeneralInfo(patientId, values)),
});

const AddPatientPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddPatientPageComponent);

export default AddPatientPage;



// WEBPACK FOOTER //
// ./client/src/components/addPatientPage/AddPatientPage.jsx